export const QuickFeedbackEnabledKey =
	"artist.feedback.quick-entry-enabled.v1";
export const AnalyticsAndImprovementsEnabledKey =
	"artist.analytics-and-improvements.enabled.v1";
export const OpenFeedbackEvent = "artist:open-feedback";
export const ExperiencePreferencesChangedEvent =
	"artist:experience-preferences-changed";

export function readBooleanPreference(
	key: string,
	defaultValue = true,
): boolean {
	if (typeof window === "undefined") return defaultValue;
	const raw = window.localStorage.getItem(key);
	if (raw === null) return defaultValue;
	return raw !== "false";
}

export function writeBooleanPreference(key: string, value: boolean): void {
	window.localStorage.setItem(key, String(value));
	window.dispatchEvent(new Event(ExperiencePreferencesChangedEvent));
}

export function openFeedbackComposer(): void {
	window.dispatchEvent(new Event(OpenFeedbackEvent));
}
